import { useState, useEffect } from "react";

/** Compte à rebours jusqu'à endIso (ISO). Rien si date absente ou passée. */
export function UrgencyCountdown({ endIso, className = "" }) {
  const [leftMs, setLeftMs] = useState(0);
  useEffect(() => {
    if (!endIso) return undefined;
    const tick = () => {
      const end = new Date(endIso).getTime();
      setLeftMs(Math.max(0, end - Date.now()));
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [endIso]);
  if (!endIso || leftMs <= 0) return null;
  const s = Math.floor(leftMs / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const label = d > 0 ? `${d}j ${h}h` : h > 0 ? `${h}h ${m}m` : `${m}m ${sec}s`;
  return (
    <p className={className}>
      Fin dans <strong>{label}</strong>
    </p>
  );
}
